module.exports = __webpack_public_path__ + "img/dz-menu-logo.f6caed5e.png";